import { useState, useEffect, useRef } from 'react';
import { SLIDES } from '../components/WalkthroughSlides';

const ORANGE = '#F37428';

export default function Walkthrough() {
  const [idx, setIdx]         = useState(0);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);
  const slide    = SLIDES[idx];
  const isLast   = idx === SLIDES.length - 1;
  const isFirst  = idx === 0;

  useEffect(() => {
    clearInterval(timerRef.current);
    setProgress(0);
    if (!playing) return;
    const duration = 7000;
    const start = Date.now();
    timerRef.current = setInterval(() => {
      const pct = Math.min((Date.now() - start) / duration, 1);
      setProgress(pct);
      if (pct >= 1) {
        clearInterval(timerRef.current);
        if (!isLast) setIdx(i => i + 1);
        else setPlaying(false);
      }
    }, 50);
    return () => clearInterval(timerRef.current);
  }, [idx, playing]);

  function go(newIdx) {
    clearInterval(timerRef.current);
    setProgress(0);
    setIdx(newIdx);
  }

  function togglePlay() {
    if (playing) { clearInterval(timerRef.current); setPlaying(false); }
    else setPlaying(true);
  }

  const MockComponent = slide.Mock;

  return (
    <div style={{
      minHeight: '100vh', background: '#0d1117',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '20px 16px', fontFamily: 'Inter, system-ui, sans-serif',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <span style={{ fontWeight: 900, fontSize: 16, color: '#fff' }}>MASTERFILE<span style={{ color: ORANGE }}>AI</span></span>
        <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 12 }}>— How It Works</span>
      </div>

      <div style={{ position: 'relative', width: '100%', maxWidth: 840, aspectRatio: '16/9', borderRadius: 14, overflow: 'hidden', boxShadow: '0 28px 80px rgba(0,0,0,0.7)' }}>
        <MockComponent />
        <div style={{ position: 'absolute', top: 12, left: 12, background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)', borderRadius: 20, padding: '3px 10px', fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.7)' }}>
          {idx + 1} / {SLIDES.length}
        </div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'rgba(255,255,255,0.1)' }}>
          <div style={{ height: '100%', width: `${progress * 100}%`, background: ORANGE, transition: 'width 0.08s linear' }} />
        </div>
      </div>

      {/* Description */}
      <div style={{ width: '100%', maxWidth: 840, marginTop: 16, minHeight: 72, paddingLeft: 4 }}>
        {slide.title && <div style={{ fontWeight: 800, fontSize: 20, color: '#fff', marginBottom: 7 }}>{slide.title}</div>}
        {slide.body  && <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>{slide.body}</div>}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 16 }}>
        <NavBtn onClick={() => go(idx - 1)} disabled={isFirst} dark>‹ Back</NavBtn>
        <button onClick={togglePlay} style={{
          background: playing ? 'transparent' : ORANGE, border: `2px solid ${ORANGE}`,
          color: playing ? ORANGE : '#fff', borderRadius: 50, width: 48, height: 48,
          fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {playing ? '⏸' : '▶'}
        </button>
        <NavBtn onClick={() => go(idx + 1)} disabled={isLast} dark>Next ›</NavBtn>
      </div>

      <div style={{ display: 'flex', gap: 7, marginTop: 14 }}>
        {SLIDES.map((_, i) => (
          <button key={i} onClick={() => go(i)} style={{
            width: i === idx ? 22 : 7, height: 7, borderRadius: 4,
            background: i === idx ? ORANGE : 'rgba(255,255,255,0.18)',
            border: 'none', cursor: 'pointer', padding: 0, transition: 'all 0.2s',
          }} />
        ))}
      </div>
    </div>
  );
}

function NavBtn({ onClick, disabled, children, dark }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: 'none',
      border: `1px solid ${dark ? 'rgba(255,255,255,0.18)' : '#e2e8f0'}`,
      color: disabled ? (dark ? 'rgba(255,255,255,0.18)' : '#e2e8f0') : (dark ? 'rgba(255,255,255,0.65)' : '#475569'),
      borderRadius: 7, padding: '8px 18px', fontSize: 13,
      cursor: disabled ? 'default' : 'pointer', fontWeight: 600,
    }}>{children}</button>
  );
}
